import { render, staticRenderFns } from "./HostingSettings.vue?vue&type=template&id=0c0089e9&"
import script from "./HostingSettings.vue?vue&type=script&lang=js&"
export * from "./HostingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports